module.exports = __webpack_public_path__ + "img/pantalla-6-2-1.55c3d59d.png";